/*
 * whatsapp-button.js
 * --------------------
 * Exports the WhatsappButton component.
 */

import React from "react";
import WhatsappIcon from "../assets/icons/whatsapp.svg";
import { useTranslation } from "../hooks/useTranslation";
import styles from "./whatsapp-button.module.scss";

const WhatsappButton = () => {
  const tComponent = useTranslation("components.WhatsappButton");

  const containerClasses = [styles.container];

  return (
    <div className={containerClasses.join(" ")}>
      <a
        className={styles.buttonLink}
        href="https://wa.me/393407923863"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        <WhatsappIcon width={24} height={24} />

        <span className={styles.label}>{tComponent("label")}</span>
      </a>
    </div>
  );
};

export default WhatsappButton;
